import { IApplicationState } from '../../../../../../types/types';

export const getSnoozeBlockerClosed = (
    state: IApplicationState
): boolean => {
    return state.kanbanView.snoozeBlockerClosed;
};
